const updateItems = [
  { id: 1, time: '3小时前', title: '某女团成员被拍到深夜与神秘男子出入酒店，粉丝集体破防', tag: '独家' },
  { id: 2, time: '6小时前', title: '知名选秀导师社交账号清空，疑似为避风头紧急操作', tag: '快讯' },
  { id: 3, time: '9小时前', title: '网红直播带货翻车现场：产品与描述严重不符引消费者集体投诉', tag: '热议' },
  { id: 4, time: '12小时前', title: '某男星前女友深夜发长文，曝光交往期间不为人知的细节', tag: '爆料' },
  { id: 5, time: '昨天 18:30', title: '综艺节目录制现场突发意外，多位嘉宾愤然离场拒绝继续拍摄', tag: '突发' },
  { id: 6, time: '昨天 14:20', title: '头部带货主播被曝与品牌方签订阴阳合同，涉及金额超千万', tag: '深扒' },
  { id: 7, time: '昨天 10:00', title: '娱乐圈知名经纪人突然宣布离职，旗下多位艺人前途未卜', tag: '快讯' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新爆料
            </h2>
            <span className="relative flex h-2.5 w-2.5 ml-1">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-500"></span>
            </span>
          </div>

          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300/60"></div>

            <div className="space-y-0">
              {updateItems.map((item) => (
                <div key={item.id} className="relative flex items-start gap-5 pb-7 last:pb-0 group cursor-pointer">
                  {/* Timeline dot */}
                  <div className="relative z-10 flex-shrink-0 w-2.5 h-2.5 mt-1.5 rounded-full bg-primary-500 group-hover:scale-150 transition-transform"></div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.time}</span>
                      <span className="text-[10px] font-semibold bg-primary-100 text-primary-700 px-1.5 py-0.5 rounded whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm font-medium text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}